module.exports = __webpack_public_path__ + "img/bg_popupTitle2.41a1bc81.png";